// 一般取藥component

<template lang="pug">

div
  div.upper-subpanel.row
    progressBar
    div.upper-subpanel--without-progressbar
      scanBarcode(v-if="stage === 'scanBarcode'" v-on:setBarcode="getBarcode")
        div.with-child-centered
          h3 請掃描藥單條碼進行
            strong 取藥
      div.row(v-if="stage === 'selectDrug'" style="width: 100%; height: 100%; margin: 0")
        //-20190410 modified by aaron
        //-div.col-12
        div.col-12(style="height: 100%")
          drugList(:singleSelection="false" :viewMode="'medList'")
      MultiFlow(v-if="stage === 'setFlowData'" 
        v-on:setAllConfirmData="getAllConfirmData"
        :startActionType="startActionType"
        :multiProgress="multiProgress"
        :confirmProgress="confirmProgress"
        :actionProgress="actionProgress"
        :barcodeData="barcodeData")
      Loader(v-if="stage === 'finish'")
  BottomButtons
    action-button(title="回主畫面" slot="button-1" @click.native="cancel" id="cancel" :clickable="currentApp.cancel")
    action-button(title="掃描條碼" slot="button-4" @click.native="stage = 'scanBarcode'" v-if="stage !== 'setFlowData' && stage !== 'finish'")
    action-button(title="全部藥物" slot="button-5" @click.native="stage = 'selectDrug'" v-if="stage !== 'setFlowData' && stage !== 'finish'")
    action-button(title="調撥藥品" slot="button-8" @click.native="startFlow('FETCH_TRANSFER')" v-if="stage === 'selectDrug'")
    action-button(title="開始取藥" slot="button-9" @click.native="startFlow('FETCH')" v-if="stage === 'selectDrug'")
</template>


<script>
import AppBase from './ComponentBase/AppBase';
import scanBarcode from './flowComp/ScanBarcode';
import selectBox from './flowComp/PositionSelection';
import drugList from './flowComp/DrugInDeviceList';
import progressBar from './flowComp/ProgressBar';
import MultiFlow from './FetchDrugFlow/MultiFlow';
import Loader from './common/Loader';
import BottomButtons from './common/BottomButtons';


export default {
  name: 'FetchDrug',
  extends: AppBase,
  components: {
    scanBarcode,
    selectBox,
    drugList,
    progressBar,
    MultiFlow,
    Loader,
    BottomButtons,
  },
  data() {
    return {
      barcodeData: {},
      startActionType: 'FETCH',
    };
  },
  computed: {
    DrugStorageWithSameDrug() {
      return this.$store.state.drugInDevice.DrugStorageWithSameDrug;
    },
    DrugStorageWithSameDrugID() {
      return this.$store.state.drugInDevice.DrugStorageWithSameDrugID;
    },
    generalSetting() {
      return this.$store.state.generalSetting;
    },
  },
  created() {
    this.stage = this.$route.params.stage || 'scanBarcode';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionProgress();
  },
  mounted() {
    this.$store.commit('SET_APP', '一般取藥');
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    this.$store.commit('SET_PROGRESS', this.progress);
  },
  methods: {
    setupProgress() {
      const prog = [];
      prog.push({ en: 'selectDrug', zh: '選擇藥物' });
      prog.push({ en: 'setFetchNum', zh: '設定處方籤數量' });
      if (this.$store.state.schedule.currentSchedule === null) {
        if (this.startActionType === 'FETCH') {
          prog.push({ en: 'MedIdInput', zh: '輸入病歷號' });
        }
        if (this.startActionType === 'FETCH_TRANSFER') {
          prog.push({ en: 'MedIdInput', zh: '輸入本單編號' });
        }
      }
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        prog.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      if (this.generalSetting.check_amount_first) {
        prog.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      prog.push({ en: 'action', zh: '進行取藥' });

      return prog;
    },
    setupConfirmProgress() {
      const prog = [];
      prog.push('setFetchNum');
      if (this.$store.state.schedule.currentSchedule === null) {
        prog.push('MedIdInput');
      }
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('actionWrap');
      return prog;
    },
    setupActionProgress() {
      const prog = [];
      if (this.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    setupMultiProgress() {
      const prog = [];
      prog.push('confirm');
      prog.push('finish');
      return prog;
    },
    cancel() {
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_FETCH' });
      this.$router.push({ name: 'Main' });
    },
    startFlow(startActionType) {
      if (Object.keys(this.$store.state.drugInDevice.selectedDrugInDevice).length === 0) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請至少選擇一項儲存藥物' });
      } else {
        this.$store.dispatch('fromFirstDrugInDevice');
        this.stage = 'setFlowData';
        this.startActionType = startActionType;
        this.$store.commit('SET_PROGRESS', this.progress);
      }
    },
    getAllConfirmData() {
      // refetch data
      this.$store.dispatch('resetAll');
      this.$store.dispatch('getSystemInfo');
      this.$store.dispatch('getDrugInDevices');
      this.stage = 'scanBarcode';
      this.barcodeData = {};
    },
    getBarcode(data) {
      console.log(data);
      // 長庚: 料位號 (3碼) + 數量(3碼) + 病歷號(7碼)
      const barcodeString = data.toString();
      //20190424 modified
      var code;
      var amount;
      var medRecordId;
      console.log('barcodeLen:',barcodeString.length);
      if(barcodeString.length>=20 && barcodeString.length<=22)
      {
        console.log('new barcode type');
        code = barcodeString.slice(0, 3);
        amount = parseInt(barcodeString.slice(3, 6), 10);
        medRecordId = barcodeString.slice(6, 18);
        medRecordId=medRecordId.split(' ').join('');//filter space char  
        console.log('料位號:',code);
        console.log('數量:',amount);
        console.log('病歷號:',medRecordId );
      }
      else
      {
        console.log('old barcode type');
        code = barcodeString.slice(0, 3);
        amount = parseInt(barcodeString.slice(3, 6), 10);
        medRecordId = barcodeString.slice(6, barcodeString.length).split('\r')[0];
        //20190510 新增化療藥局的病歷號會帶空白
        medRecordId=medRecordId.split(' ').join('');//filter space char
        console.log('料位號:',code);
        console.log('數量:',amount);
        console.log('病歷號:',medRecordId );
      }
      
      this.instance.get(`/api/medication/?CGMH_number=${code}`)
      .then(async (res) => {
        if (res.data.results.length === 0) {
          this.$store.commit('SET_MESSAGE', { type: 'warn', context: '資料庫查無此藥' });
        } else {
          const medId = res.data.results[0].id;
          await this.$store.dispatch('getDrugInDevicesWithSameDrug', medId);
          if (Object.keys(this.DrugStorageWithSameDrug).length === 0) {
            this.$store.commit('SET_MESSAGE', { type: 'warn', context: '藥櫃無存放此藥物或此藥物已取完' });
          } else {
            const drugStorage = this.DrugStorageWithSameDrug[this.DrugStorageWithSameDrugID[0]];
            this.$store.commit('SELECT_DRUG_IN_DEVICES_FROM_SELECTED', drugStorage.id);
            await this.$store.dispatch('fromFirstDrugInDevice');
            this.barcodeData.amount = amount;
            this.barcodeData.medRecordId = medRecordId;
            this.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', drugStorage.device.id);
            console.log('start flow');
            this.$store.commit('SET_MED_RECORD_NO', medRecordId);
            this.stage = 'setFlowData';
          }
        }
      });
    },
  },
  watch: {
    stage(val) {
      if (val === 'scanBarcode') {
        this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
      } else {
        this.$store.commit('SET_CURRENT_STEP', val);
      }

      if (val === 'scanBarcode' || val === 'selectDrug') {
        this.$store.commit('SHOW_LOGOUT', true);
      } else {
        this.$store.commit('SHOW_LOGOUT', false);
      }
    },
  },
};
</script>


<style lang="sass">


</style>



// WEBPACK FOOTER //
// FetchDrug.vue?acf72934